// FearGreedWidget/FearGreedFaceIcons.jsx
// Pure render helper — builds the emoji-style face SVG per segment icon key.
// No state, no logic beyond the switch — component stays a painter, not a decision-maker.
import React from 'react';

const DARK_RED = '#4A0A0A';
const DARK_BROWN = '#664500';

/**
 * @param {string} icon - one of scream|worried|neutral|smile|money
 * @param {string} fill - segment color for the face
 * @returns {JSX.Element}
 */
export function getFaceIcon(icon, fill) {
    switch (icon) {
        case 'scream':
            return (
                <svg width="26" height="26" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10.5" fill={fill} />
                    <path d="M 6 7.5 L 9.5 9" stroke={DARK_RED} strokeWidth="1.4" strokeLinecap="round" />
                    <path d="M 18 7.5 L 14.5 9" stroke={DARK_RED} strokeWidth="1.4" strokeLinecap="round" />
                    <ellipse cx="8.5" cy="11.5" rx="1.6" ry="2" fill={DARK_RED} />
                    <ellipse cx="15.5" cy="11.5" rx="1.6" ry="2" fill={DARK_RED} />
                    <ellipse cx="12" cy="17" rx="3.2" ry="3.6" fill={DARK_RED} />
                </svg>
            );
        case 'worried':
            return (
                <svg width="26" height="26" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10.5" fill={fill} />
                    <path d="M 6.5 8.5 L 9.5 9.8" stroke={DARK_RED} strokeWidth="1.4" strokeLinecap="round" />
                    <path d="M 17.5 8.5 L 14.5 9.8" stroke={DARK_RED} strokeWidth="1.4" strokeLinecap="round" />
                    <circle cx="8.5" cy="11.5" r="1.4" fill={DARK_RED} />
                    <circle cx="15.5" cy="11.5" r="1.4" fill={DARK_RED} />
                    <path d="M 7 18 Q 12 14 17 18" fill="none" stroke={DARK_RED} strokeWidth="1.8" strokeLinecap="round" />
                    <ellipse cx="18.5" cy="12.5" rx="1.1" ry="1.6" fill="#5EC8F2" />
                </svg>
            );
        case 'smile':
            return (
                <svg width="26" height="26" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10.5" fill={fill} />
                    <circle cx="8.5" cy="10.5" r="1.4" fill={DARK_BROWN} />
                    <circle cx="15.5" cy="10.5" r="1.4" fill={DARK_BROWN} />
                    <path d="M 7 15 Q 12 20 17 15" fill="none" stroke={DARK_BROWN} strokeWidth="1.8" strokeLinecap="round" />
                </svg>
            );
        case 'money':
            return (
                <svg width="26" height="30" viewBox="0 0 24 28">
                    <circle cx="8" cy="6.5" r="1.1" fill="#D4537E" />
                    <circle cx="19" cy="5" r="0.9" fill="#378ADD" />
                    <circle cx="3" cy="3" r="0.9" fill="#639922" />
                    <circle cx="21" cy="13" r="0.9" fill="#BA7517" />
                    <polygon points="12,0 8.5,6.5 15.5,6.5" fill="#D85A30" />
                    <circle cx="12" cy="0.3" r="1" fill="#FAC775" />
                    <circle cx="12" cy="16.5" r="10.5" fill={fill} />
                    <text x="8.5" y="17.5" fontSize="6" fontWeight="700" fill={DARK_BROWN} textAnchor="middle">$</text>
                    <text x="15.5" y="17.5" fontSize="6" fontWeight="700" fill={DARK_BROWN} textAnchor="middle">$</text>
                    <path d="M 7 19.5 Q 12 25.5 17 19.5" fill="none" stroke={DARK_BROWN} strokeWidth="1.8" strokeLinecap="round" />
                    <path d="M 10 23 Q 12 26 13.5 23.5" fill="#D4537E" stroke="none" />
                </svg>
            );
        case 'neutral':
        default:
            return (
                <svg width="26" height="26" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10.5" fill={fill} />
                    <circle cx="8.5" cy="11" r="1.4" fill={DARK_BROWN} />
                    <circle cx="15.5" cy="11" r="1.4" fill={DARK_BROWN} />
                    <path d="M 7.5 16.5 L 16.5 16.5" stroke={DARK_BROWN} strokeWidth="1.8" strokeLinecap="round" />
                </svg>
            );
    }
}
